/* eslint-disable prefer-promise-reject-errors */
const contentstack = require('contentstack');
import profileUtils from '../repositories/profileUtils';

function detectStage(url = window.location.href) {
    const parsed = new URL(url);
    const host = parsed.hostname;
    switch (host) {
        case 'apps.dev.nuskin.io':
        case 'dev.nuskin.com':
            return 'dev';
        case 'localhost':
            return 'local';
        case 'test.nuskin.com':
            return 'test';
        case 'www.nuskin.com':
            return 'prod';
    }
}

let apiKey, deliveryToken, environment;

const language = profileUtils.getLanguage();
const country = profileUtils.getCountry();

let locale = `${country}-${language}`

switch (locale) {
    case 'ID-in':
        locale = 'ID-id'
        break
    default:
}

const stage = detectStage();

try {
    const environmentConfig = require(`../../config/${stage}.json`);
    apiKey = environmentConfig.contentstack.apiKey;
    deliveryToken = environmentConfig.contentstack.deliveryToken;
    environment = environmentConfig.contentstack.environment;
} catch (error) {
    console.error(
        `Error retrieving environment config. Environment: '${stage}' : ${error}`
    );
}

const Stack = contentstack.Stack({
    api_key: apiKey,
    delivery_token: deliveryToken,
    environment,
    region: 'us' 
});

if (process.env.custom_host) {
    Stack.setHost(process.env.custom_host);
}

function getConfig(title) {
    const data = new Promise((resolve, reject) => {
        Stack.ContentType('config_map')
            .Query()
            .where('title', title)
            .toJSON()
            .find()
            .then(
                async function success(result) {
                    if (result) {
                        let configObj = {}
                        for (let i = 0; i < result[0][0].configs.length; i++) {
                            let overrideObj = {}
                            let config = await getSubEntry(
                                result[0][0].configs[i]._content_type_uid,
                                result[0][0].configs[i].uid
                            )
                            if (config.market_overrides.length) {
                                overrideObj = config.market_overrides.reduce(
                                    (accum, { markets }) => ({
                                        ...accum,
                                        [markets.market]: markets.value
                                    }),
                                    {}
                                )
                            }
                            if (overrideObj[country]) {
                                configObj[config.title] = overrideObj[country]
                            } else {
                                configObj[config.title] = config.value
                            }
                        }
                        resolve(configObj)
                    } else {
                        return reject('Internal Error')
                    }
                },
                function error(error) {
                    return reject(error)
                }
            )
    })
    return data
}
  

function getEntry(contentTypeUid) {
    const data = new Promise((resolve, reject) => {
        Stack.ContentType(contentTypeUid)
            .Query()
            .language(locale)
            .includeFallback()
            .toJSON()
            .find()
            .then(
                function success(result) {
                    if (result) {
                        resolve(result[0]);
                    } else {
                        return reject('Internal Error');
                    }
                },
                function error(error) {
                    return reject(error);
                }
            );
    });
    return data;
}

function getSubEntry(type, uuid) {
    const data = new Promise((resolve, reject) => {
        Stack.ContentType(type)
            .Entry(uuid)
            .language(locale)
            .includeFallback()
            .fetch()
            .then(
                function success(entry) {
                    if (entry) {
                        resolve(entry.toJSON());
                    } else {
                        reject('Error');
                    }
                },
                function error(err) {
                    reject(err);
                }
            );
    });
    return data;
}

async function getSharedStrings(strings) {
    let sharedStrings = {};
    for (let i = 0; i < strings[0].shared_strings.length; i++) {
        const element = strings[0].shared_strings[i];
        try {
            let common = await getSubEntry(
                element._content_type_uid,
                element.uid
            );
            sharedStrings[common.key] = common.strings.reduce(
                (result, { key, value }) => ({ ...result, [key]: value }),
                {}
            );
        } catch (e) {
            console.log('Error in getSubEntry: ', e);
        }
    }
    return sharedStrings;
}

function replaceEmptyStringsWithDefaultStrings(strings, defaultStrings) {
    // filter those strings and replace the empty with the default values

    // This is set up to trigger the string keys to show instead of the default
    // To get keys to show, put "?keys" at the end of the URL
    const urlSegments = window.location.href.split('?')
    const searchParams = new URLSearchParams(urlSegments[1]);
    const displayKeys = searchParams.has('keys')

    function iterateOverObjectToCheckForNestedObjects(objectStrings, recursiveDefaultStrings) {
        for (const property in objectStrings) {
            if(typeof objectStrings[property] === 'object') {
                iterateOverObjectToCheckForNestedObjects(objectStrings[property], recursiveDefaultStrings[property])
            } else if(objectStrings[property] === '' && !displayKeys){
                objectStrings[property] = recursiveDefaultStrings[property]
            } else if(objectStrings[property] === '' && displayKeys){
                let stringKeys = `{{{ ${Object.keys(strings[0])} }}}`
                objectStrings[property] = stringKeys[stringKeys.indexOf(property)]
            }
        }
        return objectStrings
    }
    if(Array.isArray(strings)){
        if(displayKeys){
            let stringKeys = Object.keys(strings[0])
            let modifiedStrings = [...strings]
            modifiedStrings.forEach(object => {
                for (const property in object) {
                    if (object[property] === '') {
                        object[property] = `{{{ ${stringKeys[stringKeys.indexOf(property)]} }}}`
                    }
                }
            });
            return modifiedStrings
        } else {
            let modifiedStrings = [...strings]
            modifiedStrings.forEach(object => {
                for (const property in object) {
                    if (object[property] === '') {
                        object[property] = defaultStrings[property]
                    }
                }
            });
            return modifiedStrings
        }
    } else if(typeof strings === 'object') {
        let inputStrings = {...strings}
        let modifiedStrings = iterateOverObjectToCheckForNestedObjects(inputStrings, defaultStrings)
        return modifiedStrings
    }
}

export default {
    getEntry,
    getSubEntry,
    getSharedStrings,
    getConfig,
    replaceEmptyStringsWithDefaultStrings
};
